import { OnboardingTasksAPI } from '@weave/schema-gen-ts/dist/schemas/insys/onboarding/v1/onboarding-tasks/onboarding_tasks.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaOnboardingTasksV1Service = bindHTTP(OnboardingTasksAPI);
export const serviceName = 'onboarding-tasks-v1' as const;
